import { useState } from 'react'
import { NumberField } from '@/components/NumberField'

/* ---------- helpers ---------- */

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16'>
			<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
				{title}
			</h3>
			{children}
		</div>
	)
}

/* ---------- sandbox ---------- */

export function NumberFieldSandbox () {
	const [basicValue, setBasicValue] = useState<number | undefined>(0)
	const [priceValue, setPriceValue] = useState<number | undefined>(1500)
	const [steppedValue, setSteppedValue] = useState<number | undefined>(500)

	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			{/* ── Basic ── */}
			<Section title='Basic'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<NumberField
						value={basicValue}
						placeholder='Enter a number'
						onValueChange={setBasicValue}
						onClear={() => setBasicValue(undefined)}
					/>
					<span className='spaces:text-12 spaces:text-content-3'>Value: {basicValue ?? '—'}</span>
				</div>
			</Section>

			{/* ── With label ── */}
			<Section title='With Label'>
				<div className='spaces:w-[280px]'>
					<NumberField
						label='Number of Bedrooms'
						value={basicValue}
						placeholder='Any'
						onValueChange={setBasicValue}
						onClear={() => setBasicValue(undefined)}
						min={0}
						max={5}
					/>
				</div>
			</Section>

			{/* ── Prefix ── */}
			<Section title='Prefix'>
				<div className='spaces:flex spaces:flex-col spaces:gap-16 spaces:w-[280px]'>
					<NumberField
						label='Monthly Rent'
						prefix='$'
						value={priceValue}
						placeholder='Any'
						onValueChange={setPriceValue}
						onClear={() => setPriceValue(undefined)}
						min={0}
						step={50}
					/>
				</div>
			</Section>

			{/* ── Min / Max / Step ── */}
			<Section title='Min / Max / Step'>
				<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:w-[280px]'>
					<NumberField
						label='Price (step $100, min $500, max $5000)'
						prefix='$'
						value={steppedValue}
						placeholder='Any'
						onValueChange={setSteppedValue}
						onClear={() => setSteppedValue(undefined)}
						min={500}
						max={5000}
						step={100}
					/>
					<span className='spaces:text-12 spaces:text-content-3'>
						Value: {steppedValue ?? '—'}
					</span>
				</div>
			</Section>

			{/* ── Disabled ── */}
			<Section title='Disabled'>
				<div className='spaces:flex spaces:flex-col spaces:gap-16 spaces:w-[280px]'>
					<NumberField label='Disabled (no prefix)' value={42} disabled />
					<NumberField
						label='Disabled with prefix'
						prefix='$'
						value={1200}
						disabled
					/>
				</div>
			</Section>
		</div>
	)
}
